import { createSelector } from 'reselect';

const selectServices = (state: any) => state.services;


export const selectServicesCurrentItem = createSelector([selectServices], (services) => services.current);

export const selectServicesListItems = createSelector([selectServices], (services) => services.list);

export const selectServicesItemById = (itemId: any) =>
    createSelector(selectServicesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectServicesQueryItems = createSelector([selectServices], (services) => services.query);

export const selectServicesCreatedItem = createSelector([selectServices], (services) => services.create);

export const selectServicesUpdatedItem = createSelector([selectServices], (services) => services.update);

export const selectServicesReadItem = createSelector([selectServices], (services) => services.read);

export const selectServicesDeletedItem = createSelector([selectServices], (services) => services.delete);

export const selectServicesSearchedItems = createSelector([selectServices], (services) => services.search);

export const selectServicesItemsCount = createSelector([selectServices], (services) => services.count);

export const selectServicesItemsFilter = createSelector([selectServices], (services) => services.filter);